Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buzzsprout = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Buzzsprout = function Buzzsprout(_ref) {
  var buzzsproutId = _ref.buzzsproutId,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '200' : _ref$height;
  var regex = /^\d{7}\/\d{7}-[\w|\W]+/;
  if (!regex.test(buzzsproutId)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "buzzsprout",
    className: "buzzsprout-mdx-embed",
    title: "buzzsprout-".concat(buzzsproutId),
    src: "https://www.buzzsprout.com/".concat(buzzsproutId, "?client_source=admin&amp;iframe=true"),
    width: width,
    height: height,
    frameBorder: "0",
    scrolling: "no"
  })));
};
exports.Buzzsprout = Buzzsprout;